/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `WaypointDirection.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { WaypointDirection } from "./WaypointDirection";

import { Area } from "./Area";
import { WaypointStep } from "./WaypointStep";

export abstract class WaypointDirectionModel {
    id: number;
    areaId: number;
    createdAt: Dayjs;
    updatedAt: Dayjs;
    area: Area | null | undefined;
    waypointSteps: WaypointStep[] | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        areaId: number,
        createdAt: Dayjs,
        updatedAt: Dayjs,
        area: Area | null | undefined,
        waypointSteps: WaypointStep[] | undefined
    ) {
        this.id = id;
        this.areaId = areaId;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.area = area;
        this.waypointSteps = waypointSteps;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): WaypointDirection {
        const newObject = new WaypointDirection(
            json["id"],
            json["area_id"],
            dayjs(json["created_at"]).tz(timezone),
            dayjs(json["updated_at"]).tz(timezone),
            json["area"] == null ? json["area"] : Area.fromApiObject(json["area"], timezone),
            json["waypoint_steps"]?.map((item: any) => WaypointStep.fromApiObject(item, timezone))
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(): any {
        return {
            id: this.id,
            area_id: this.areaId,
            created_at: this.createdAt,
            updated_at: this.updatedAt,
            waypoint_steps_attributes: this.waypointSteps?.map((item) => item.toApiObject()),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): WaypointDirection {
        const clone = Object.create(this) as WaypointDirection;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
